import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import PageHeader from 'components/Common/PageHeader';
import LayoutGap from '@/components/Common/LayoutGap';
import useCreateSegment from '@/refactored/hooks/useSegment';
import type { SegmentDetailsFormValues } from '@/components/Pages/Segments/schema';
import SegmentDetailsForm from '@/components/Pages/Segments/CreateSegment/SegmentDetailsForm';
import { tryCatch } from '@/utils/tryCatch';

const CreateSegmentPage = () => {
  const navigate = useNavigate();
  const [{ loading, error }, createSegment] = useCreateSegment();

  const handleSubmit = async (data: SegmentDetailsFormValues) => {
    const newData = {
      ...data,
      rules: data.rules.map((rule) => {
        if (rule.ruleType === 'purchases') {
          const { dateRange, ...rest } = rule;
          return {
            ...rest,
            startDate: dateRange.from,
            endDate: dateRange.to,
          };
        }
        return rule;
      }),
    };

    const [err] = await tryCatch(createSegment({ data: newData }));

    if (err) {
      toast.error('Error creating segment');
      return;
    }

    toast.success('Segment created successfully');
    // TODO: navigate to the new segment. Currently response is not returning the id
    navigate('/segments');
  };

  return (
    <LayoutGap direction="column">
      <PageHeader title="Create Segment" className="mx-6 mt-4" />
      <div className="mx-6">
        <SegmentDetailsForm
          onSubmit={handleSubmit}
          isSubmitting={loading}
          submitError={error}
        />
      </div>
    </LayoutGap>
  );
};

export default CreateSegmentPage;
